import { render, staticRenderFns } from "./RemoveUserFromCohort.vue?vue&type=template&id=5d87d1ca&scoped=true&"
import script from "./RemoveUserFromCohort.vue?vue&type=script&lang=js&"
export * from "./RemoveUserFromCohort.vue?vue&type=script&lang=js&"
import style0 from "./RemoveUserFromCohort.vue?vue&type=style&index=0&id=5d87d1ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d87d1ca",
  null
  
)

export default component.exports